import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./page/home";
import Traceability from "./page/traceability";
import Login from "./page/login";
import Dashboard from "./page/dashboard";
import PerusahaanAddHarga from "./page/perusahaan/perusahaan-add-harga";
import PerusahaanEditHarga from "./page/perusahaan/perusahaan-edit-harga";
import RencanaTanam from "./page/RencanaTanam";
import AddRencanaTanam from "./page/petani/PetaniAddRencanaTanam";
import OrderMasuk from "./page/OrderMasuk";
import LogistikApprove from "./page/logistik/LogistikApproveOrder";
import OrderAktif from "./page/OrderAktif";
import HistoryPanen from "./page/history-panen";
import AddOrder from "./page/AddOrder";
import UpdateOrder from "./page/update-order";
import LogistikTransaksi from "./page/logistik/LogistikTransaksi";
import UpdateHargaAktual from "./page/perusahaan/perusahaan-aktual";
import TerimaOrder from "./page/terima-order";
import Users from "./page/admin/users";
import AddUser from "./page/admin/add-user";
import EditUser from "./page/admin/edit-user";
import PerusahaanProfile from "./page/perusahaan/perusahaan-profile";
import PerusahaanProfileEdit from "./page/perusahaan/perusahaan-profile-edit";
import PetaniLahan from "./page/petani/PetaniLahan";
import PetaniAddLahan from "./page/petani/PetaniAddLahan";
import PetaniEditLahan from "./page/petani/petani-edit-lahan";
import PetaniProfile from "./page/petani/petani-profile";
import PetaniProfileEdit from "./page/petani/petani-profile-edit";
import PabrikList from "./page/pabrik/PabrikDasar";
import PabrikAddList from "./page/pabrik/PabrikAddDasar";
import PabrikEditList from "./page/pabrik/PabrikEditDasar";
import PabrikProfile from "./page/pabrik/pabrik-profile";
import LogistikList from "./page/logistik/LogistikDasar";
import LogistikListAdd from "./page/logistik/LogistikAddDasar";
import LogistikListEdit from "./page/logistik/LogistikDasarEdit";
import LogistikProfile from "./page/logistik/logistik-profile";
import LogistikProfileEdit from "./page/logistik/logistik-profile-edit";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import PabrikProfileEdit from "./page/pabrik/pabrik-profile-edit";

function App() {
  return (
    <div className="Cassava Super">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/traceability" element={<Traceability />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/update-harga" element={<PerusahaanAddHarga />} />
          <Route
            path="/perusahaan-edit/:id"
            element={<PerusahaanEditHarga />}
          />
          <Route path="/rencanatanam" element={<RencanaTanam />} />
          <Route path="/rencanatanam/add" element={<AddRencanaTanam />} />
          <Route path="/ordermasuk" element={<OrderMasuk />} />
          <Route path="/logistik-approve" element={<LogistikApprove />} />
          <Route path="/orderaktif" element={<OrderAktif />} />
          <Route path="/history-panen" element={<HistoryPanen />} />
          <Route path="/addorder" element={<AddOrder />} />
          <Route path="/transaksilogistik" element={<OrderMasuk />} />
          <Route
            path="/logistik/transaksi/:id"
            element={<LogistikTransaksi />}
          />
          <Route path="/products/update/:id" element={<UpdateOrder />} />
          <Route
            path="/orders/updateharga/:id"
            element={<UpdateHargaAktual />}
          />
          <Route path="/panen/acc/:id" element={<TerimaOrder />} />
          <Route path="/users" element={<Users />} />
          <Route path="/users/add" element={<AddUser />} />
          <Route path="/users/edit/:id" element={<EditUser />} />
          <Route path="/profile-perusahaan" element={<PerusahaanProfile />} />
          <Route
            path="/profile-perusahaan/edit/:id"
            element={<PerusahaanProfileEdit />}
          />
          <Route path="/datalahan" element={<PetaniLahan />} />
          <Route path="/datalahan/add" element={<PetaniAddLahan />} />
          <Route path="/datalahan/edit/:id" element={<PetaniEditLahan />} />
          <Route path="/profile-petani" element={<PetaniProfile />} />
          <Route
            path="/profile-petani/edit/:id"
            element={<PetaniProfileEdit />}
          />
          <Route path="/data-pabrik" element={<PabrikList />} />
          <Route path="/data-pabrik/add" element={<PabrikAddList />} />
          <Route path="/data-pabrik/edit/:id" element={<PabrikEditList />} />
          <Route path="/profile-pabrik" element={<PabrikProfile />} />
          <Route
            path="/profile-pabrik/edit/:id"
            element={<PabrikProfileEdit />}
          />
          <Route path="/data-logistik" element={<LogistikList />} />
          <Route path="/data-logistik/add" element={<LogistikListAdd />} />
          <Route
            path="/data-logistik/edit/:id"
            element={<LogistikListEdit />}
          />
          <Route path="/profile-logistik" element={<LogistikProfile />} />
          <Route
            path="/profile-logistik/edit/:id"
            element={<LogistikProfileEdit />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
